import { render, staticRenderFns } from "./marKetingPointMsg.vue?vue&type=template&id=64926dc6&scoped=true"
import script from "./marKetingPointMsg.vue?vue&type=script&lang=js"
export * from "./marKetingPointMsg.vue?vue&type=script&lang=js"
import style0 from "./marKetingPointMsg.vue?vue&type=style&index=0&id=64926dc6&prod&scoped=true&lang=css"
import style1 from "./marKetingPointMsg.vue?vue&type=style&index=1&id=64926dc6&prod&scoped=true&lang=css"
import style2 from "./marKetingPointMsg.vue?vue&type=style&index=2&id=64926dc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64926dc6",
  null
  
)

export default component.exports